import React, { useState } from 'react';
import type { Flow___InstanceConditionPartial } from '~/scenes/Automation/v2/components/UpdateAction/components/ConditionEditor';
import SelectorComp from '~/components/Selector';
import { Crumb } from '../../../Breadcrumbs';
import TEST_ID from './index.testid';
import { actionById } from '~/scenes/Automation/v2/state';
import { useRecoilValue } from 'recoil';
import useLinksFromSendEmailAction from '~/scenes/Automation/v2/components/Builder/hooks/useLinksFromSendEmailAction';
import { ListItem } from '../../../../../Selector';
import { SelectorContainerProps } from '../..';

export const linkSelectorText = {
  emptyBreadcrumbLabel: 'Selecteer een link',
  anyLink: 'Elke link',
};

const LinkSelector: React.FC<
  Omit<SelectorContainerProps, 'condition'> & {
    condition: Flow___InstanceConditionPartial;
  }
> = ({
  onClose,
  condition,
  onSelect,
  pointerLocation,
  pointerOffset,
  selectorRef,
  ...rest
}) => {
  const [currentPath, setCurrentPath] = useState([]);

  const [actionId] = condition.input.path;
  const action = useRecoilValue(actionById(actionId));

  if (action?.__typename !== 'FlowV2_Action_SendEmail_Plain') {
    throw 'No';
  }

  const links = useLinksFromSendEmailAction(action);

  const linkOptions = [
    <ListItem
      key={'emptylink'}
      onClick={e => {
        e.stopPropagation();
        onSelect({
          __typename: 'Flow___Argument_String',
          value_string: null,
        });
      }}
      data-testid={TEST_ID.LIST_ITEM}
      data-objectid={`emptylink`}
    >
      {linkSelectorText.anyLink}
    </ListItem>,
    ...links.map((link, index) => (
      <ListItem
        key={index}
        onClick={e => {
          e.stopPropagation();
          onSelect({
            __typename: 'Flow___Argument_String',
            value_string: link.url,
          });
        }}
        data-testid={TEST_ID.LIST_ITEM}
        data-objectid={`${link.url}`}
      >
        {link.text} ({link.url})
      </ListItem>
    )),
  ];

  return (
    <SelectorComp
      emptyBreadcrumbLabel={linkSelectorText.emptyBreadcrumbLabel}
      pointerPosition={{
        location: pointerLocation,
        offset: pointerOffset,
      }}
      actions={[
        {
          key: 'close',
          icon: 'close',
          appearance: 'icon',
          onClick: onClose,
        },
      ]}
      crumbs={[
        {
          label: '...',
          key: 'root',
        },
      ]}
      onBreadcrumbClick={(crumb: Crumb, index: number) => {
        if (crumb.key === 'root') {
          return setCurrentPath([]);
        }

        return setCurrentPath(currentPath.slice(0, index));
      }}
      dataTestId={TEST_ID.CONTAINER}
      ref={selectorRef}
      {...rest}
    >
      {linkOptions}
    </SelectorComp>
  );
};

export default LinkSelector;
